import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { FieldInputProps } from 'react-final-form';

interface Props {
    id: string;
    name: string;
    input: FieldInputProps<any, HTMLElement>;
    meta: any;
    disabled?: boolean;
}

export default class EntityTableRowCheckBox extends React.PureComponent<Props> {
    get checked(): boolean {
        const {
            input: { value }
        } = this.props;

        return value;
    }

    handleChange = (): void => {
        const {
            input: { value, onChange }
        } = this.props;

        onChange(!value);
    };

    render(): React.ReactElement {
        const { id, name, disabled = false } = this.props;

        return (
            <Checkbox
                id={id}
                name={name}
                checked={this.checked}
                onChange={this.handleChange}
                disabled={disabled}
            />
        );
    }
}
